// The cn helper (tailwind-merge) doesn't fully support custom tailwind classes
// so we need to handle it ourselves for those cases (max-w-*)

/** checks for max-w class, if not found, adds default class */
export const withMaxWidth = (defaultClass: string, className = '') =>
  className.includes('max-w') ? className : `${className} ${defaultClass}`;
